/* tslint:disable */

declare var Object: any;
export interface ViewHeadcountGenderInterface {
  "total": number;
  "gender": number;
}

export class ViewHeadcountGender implements ViewHeadcountGenderInterface {
  "total": number;
  "gender": number;
  constructor(data?: ViewHeadcountGenderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewHeadcountGender`.
   */
  public static getModelName() {
    return "ViewHeadcountGender";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewHeadcountGender for dynamic purposes.
  **/
  public static factory(data: ViewHeadcountGenderInterface): ViewHeadcountGender{
    return new ViewHeadcountGender(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewHeadcountGender',
      plural: 'ViewHeadcountGenders',
      path: 'ViewHeadcountGenders',
      properties: {
        "total": {
          name: 'total',
          type: 'number'
        },
        "gender": {
          name: 'gender',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewHeadcountGender.ts